<div class="indicator{{feel ? ' -feel-'+feel : ''}}{{size ? ' -size-'+size : ''}}" [ngClass]="{'-inverted': inverted}">
    <div class="indicator__inner">
        <ng-content *ngIf="!icon"></ng-content>
        <shared-icon [icon]="icon" *ngIf="icon"></shared-icon>
    </div>
</div>